import React, { useEffect, useRef, useState } from "react";
import Breadcrumbs from "../common/breadcrumbs";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Dropdown } from "primereact/dropdown";
import "rc-slider/assets/index.css";

import CarPackagesSelect from "../common/carPackagesSelect";
import { all_routes } from "../router/all_routes";
import { defaultDropOffDate, defaultDropOffTime, defaultPickUpDate, defaultPickUpTime, ListCarsData, ListMasterData, S3CDNURL, showTitleMaster } from "../../functionsMaster";
import SearchForm from "../common/searchForm";

const ListingGrid = () => {
  const [message, setMessage] = useState({ status: 0, value: '' });
  const [advanceFilter, setAdvanceFilter] = useState(false);
  const ListCarsRef = useRef(null);
  const scrollToListCars = () => {
    ListCarsRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const routes = all_routes;
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [selectedSort, setSelectedSort] = useState(null);
  
  const number = [
    { name: "5" },
    { name: "10" },
    { name: "15" },
    { name: "20" },
    { name: "25" },
    { name: "30" },
  ];
  const sort = [
    { name: "Newest" },
    { name: "Relevance" },
    { name: "Low to High" },
    { name: "High to Low" },
    { name: "Best Rated" },
    { name: "Distance" },
    { name: "Popularity" },
  ];

  const [carData, setCarData] = useState([]);
  useEffect(() => {
      const fetchData = async () => {
      const temp = await ListCarsData({ status: 1 });
      // Do something with data, like setting it to state
      setCarData(temp.data);
      setTimeout(() => {
        // ListCarsRef.current?.scrollIntoView({ behavior: "smooth" });
        scrollToListCars();
      }, 786);
    };
  fetchData();
}, []);

  const [carCategory, setCarCategory] = useState([]); // temp
  const [carBrand, setCarBrand] = useState([]); // temp1
  // const [carModel, setCarModel] = useState([]); // temp2
  const [carColor, setCarColor] = useState([]); // temp3
  const [carSeat, setCarSeat] = useState([]); // temp4
   const [carFuel, setCarFuel] = useState([]); // temp5
  // const [carDoor, setCarDoor] = useState([]); // temp6
  // const [carCylinder, setCylinder] = useState([]); // temp7
  const [carTransmission, setCarTransmission] = useState([]); // temp8
  const [carSteering, setCarSteering] = useState([]); // temp9
  const [carFeatures, setCarFeatures] = useState([]); // temp10
  // const [carSafetyFeatures, setCarSafetyFeatures] = useState([]); // temp11

  // const [branchLocation, setBranchLocation] = useState([]); // temp12
  const [carsPackages, setCarsPackages] = useState([]); // temp13 
  const [selectedPackage, setSelectedPackage] = useState(localStorage.getItem('pkgID'));
  
  const [pickUpDate] = useState(defaultPickUpDate());
  const [pickUpTime] = useState(defaultPickUpTime());
  const [dropOffDate] = useState(defaultDropOffDate());
  const [dropOffTime] = useState(defaultDropOffTime());

useEffect(() => {
  const CACHE_DURATION = 4 * 60 * 60 * 1000; // 4 hours in milliseconds

  const fetchData = async () => {    
    const temp = await ListMasterData('carsPackages', { status: 1 });
    setCarsPackages(temp.data && temp.data.length > 0 ? temp.data : []);

    const config = [
      { key: 'carCategory', setter: setCarCategory },
      { key: 'carBrand', setter: setCarBrand },
      // { key: 'carModel', setter: setCarModel },
      { key: 'carColor', setter: setCarColor },
      { key: 'carSeat', setter: setCarSeat },
      { key: 'carFuel', setter: setCarFuel },
      // { key: 'carDoor', setter: setCarDoor },
      // { key: 'carCylinder', setter: setCylinder },
      { key: 'carTransmission', setter: setCarTransmission },
      { key: 'carSteering', setter: setCarSteering },
      { key: 'carFeatures', setter: setCarFeatures },
      // { key: 'carSafetyFeatures', setter: setCarSafetyFeatures },
      // { key: 'branchLocation', setter: setBranchLocation },
    ];

    await Promise.all(
      config.map(async ({ key, setter }) => {
        const cacheKey = `masterData_${key}`;
        const cacheRaw = localStorage.getItem(cacheKey);

        if (cacheRaw) {
          const { timestamp, data } = JSON.parse(cacheRaw);
          const isExpired = Date.now() - timestamp > CACHE_DURATION;

          if (!isExpired && Array.isArray(data)) {
            setter(data);
            return;
          }
        }

        // Fetch from API if not cached or expired
        try {
          const res = await ListMasterData(key, { status: 1, limitedData: 'Yes' });
          const data = Array.isArray(res.data) ? res.data : [];
          setter(data);
          if (data && data.length > 0) {
            localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data }));
          }
        } catch (err) {
          console.error(`Failed to fetch ${key}`, err);
          setter([]);
        }
      })
    );
  };

  fetchData();
}, []);
  

  return (
    <div className="listing-page">
      <Breadcrumbs title="Car Listings" subtitle="Listings" />
      {/* Search */}
      <SearchForm
        message={message}
        setMessage={setMessage}
        scrollToListCars={scrollToListCars}
        advanceFilter={advanceFilter}
        setAdvanceFilter={setAdvanceFilter}
      />
      {/* /Search */}
      {/* Sort By */}
      <div className="sort-section d-none">
        <div className="container">
          <div className="sortby-sec">
            <div className="sorting-div">
              <div className="row d-flex align-items-center">
                <div className="col-xl-4 col-lg-3 col-sm-12 col-12">
                  <div className="count-search">
                    <p>Showing 1-9 of 154 Cars</p>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-9 col-sm-12 col-12">
                  <div className="product-filter-group">
                    <div className="sortbyset">
                      <ul className="d-flex">
                        <li>
                          <span className="sortbytitle">Show : </span>
                          <div className="sorting-select select-one">
                            <Dropdown
                              value={selectedNumber}
                              onChange={(e:any) => setSelectedNumber(e.value)}
                              options={number}
                              optionLabel="name"
                              placeholder="5"
                            />
                          </div>
                        </li>
                        <li>
                          <span className="sortbytitle">Sort By </span>
                          <div className="sorting-select select-two">
                            <Dropdown
                              value={selectedSort}
                              onChange={(e:any) => setSelectedSort(e.value)}
                              options={sort}
                              optionLabel="name"
                              placeholder="Newest"
                              className="w-100"
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="grid-listview">
                      <ul>
                        <li>
                          <Link to={routes.listingGrid} className="active">
                            <i className="feather icon-grid" />
                          </Link>
                        </li>
                        <li>
                          <Link to={routes.listingList}>
                            <i className="feather icon-list" />
                          </Link>
                        </li>
                        <li>
                          <Link to={all_routes.listingMap}>
                            <i className="feather icon-map-pin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Sort By */}
      {/* Car Grid View */}
      <section className={`section mt-3 car-listing pt-0 ${message.value !== "" && "d-none"}`}>
        <div className="container">
          <div className="row">
            <div className={`col-xl-3 col-lg-4 col-sm-12 col-12 theiaStickySidebar ${advanceFilter ? '' : 'd-none'}`}>
              <div className="stickybar">
                <form autoComplete="off" className="sidebar-form">
                  <div className="accord-list">
                    <div className="accordion" id="accordionMain1">
                      <div className="card-header-new" id="headingOne">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Car Brand
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample1"
                      >
                        <div className="card-body-chat">
                          <div className="row">
                            <div className="col-md-12">
                              <div id="checkBoxes1">
                                <div className="selectBox-cont">
                                  {carBrand && carBrand.map((s) => (
                                    <label key={s._id} className="custom_check w-100">
                                      <input type="checkbox" name="username" value={s._id} />
                                      <span className="checkmark" /> {s.title}
                                    </label>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion" id="accordionMain2">
                      <div className="card-header-new" id="headingTwo">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="true"
                            aria-controls="collapseTwo"
                          >
                            Car Category
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="card-body-chat">
                          <div id="checkBoxes2">
                            <div className="selectBox-cont">
                              {carCategory && carCategory.map((s) => (
                                  <label key={s._id} className="custom_check w-100">
                                    <input type="checkbox" name="username" value={s._id} />
                                    <span className="checkmark" /> {s.title}
                                  </label>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion" id="accordionMain04">
                      <div className="card-header-new" id="headingfuel">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefuel"
                            aria-expanded="true"
                            aria-controls="collapsefuel"
                          >
                            Fuel Type
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapsefuel"
                        className="collapse"
                        aria-labelledby="headingfuel"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="card-body-chat">
                          <div className="fuel-list">
                            <ul>
                              {carCategory && carCategory.map((s, i) => (
                                <li key={s._id}>
                                  <div className="input-selection">
                                    <input
                                      type="radio"
                                      name="category"
                                      id={`category${s._id}`}
                                      value={s.title}
                                      defaultChecked={i === 0}
                                    />
                                    <label htmlFor="petrol">{s.title}</label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="accordion" id="accordionMain06">
                      <div className="card-header-new" id="headingspec">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsespec"
                            aria-expanded="true"
                            aria-controls="collapsespec"
                          >
                            Car Specifications
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapsespec"
                        className="collapse"
                        aria-labelledby="headingspec"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="card-body-chat">
                          <div id="checkBoxes20">
                            <div className="selectBox-cont">
                                {carFeatures && carFeatures.map((s) => (
                                  <label key={s._id} className="custom_check w-100">
                                    <input type="checkbox" name="username" value={s._id} />
                                    <span className="checkmark" /> {s.title}
                                  </label>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="accordion" id="accordionMain7">
                      <div className="card-header-new" id="headingColor">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseColor"
                            aria-expanded="true"
                            aria-controls="collapseColor"
                          >
                            Colors
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapseColor"
                        className="collapse"
                        aria-labelledby="headingColor"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="card-body-chat">
                          <div className="theme-colorsset">
                            <ul>
                              {carColor && carColor .map((s) => (
                                <li key={s._id}>
                                  <div className="input-themeselects">
                                    <input
                                      type="radio"
                                      name="color"
                                      id={`Color${s._id}`}
                                      defaultValue={s.title}
                                      defaultChecked
                                    />
                                    <label
                                      htmlFor={`Color${s._id}`}
                                      className={`${s.title.toLowerCase()}-clr`}
                                    />
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="accordion" id="accordionMain8">
                      <div className="card-header-new" id="headingThree">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="true"
                            aria-controls="collapseThree"
                          >
                            Capacity
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapseThree"
                        className="collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample3"
                      >
                        <div className="card-body-chat">
                          <div id="checkBoxes3">
                            <div className="selectBox-cont">
                              {carSeat && carSeat .map((s) => (
                                <label key={s._id} className="custom_check w-100">
                                  <input type="checkbox" name="bystatus" />
                                  <span className="checkmark" /> {s.title}
                                </label>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion" id="accordionMain4">
                      <div className="card-header-new" id="headingtransmiss">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsetransmission"
                            aria-expanded="true"
                            aria-controls="collapsetransmission"
                          >
                            Transmission
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapsetransmission"
                        className="collapse"
                        aria-labelledby="headingtransmiss"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="card-body-chat">
                          <div className="fuel-list">
                            <ul>
                              {carTransmission && carTransmission.map((s, i) => (
                                <li key={s._id}>
                                  <div className="input-selection">
                                    <input
                                      type="radio"
                                      name="transmission"
                                      id={`carSeats${s._id}`}
                                      checked={i === 0}
                                    />
                                    <label htmlFor={`carSeats${s._id}`}>{s.title}</label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="accordion" id="accordionMain10">
                      <div className="card-header-new" id="headingFive">
                        <h6 className="filter-title">
                          <Link
                            to="#"
                            className="w-100 collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="true"
                            aria-controls="collapseFive"
                          >
                            Rating
                            <span className="float-end">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </Link>
                        </h6>
                      </div>
                      <div
                        id="collapseFive"
                        className="collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample5"
                      >
                        <div className="card-body-chat">
                          <div id="checkBoxes4">
                            <div className="selectBox-cont">
                              <label className="custom_check w-100">
                                <input type="checkbox" name="category" />
                                <span className="checkmark" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <span className="rating-count">5.0</span>
                              </label>
                              <label className="custom_check w-100">
                                <input type="checkbox" name="category" />
                                <span className="checkmark" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star" />
                                <span className="rating-count">4.0</span>
                              </label>
                              <label className="custom_check w-100">
                                <input type="checkbox" name="category" />
                                <span className="checkmark" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <span className="rating-count">3.0</span>
                              </label>
                              <label className="custom_check w-100">
                                <input type="checkbox" name="category" />
                                <span className="checkmark" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <span className="rating-count">2.0</span>
                              </label>
                              <label className="custom_check w-100">
                                <input type="checkbox" name="username" />
                                <span className="checkmark" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <i className="fas fa-star" />
                                <span className="rating-count">1.0</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <Link
                    to="/listings/cars"
                    className="text-white d-inline-flex align-items-center justify-content-center btn w-100 btn-danger filter-btn"
                  >
                    Reset Filter
                  </Link>
                </form>
              </div>
            </div>
            <div className={advanceFilter ? 'col-lg-9' : 'col-lg-12'}>
              <div className="row" ref={ListCarsRef}>
                {/* col */}
                {carData && carData.map((s) => (
                  <div key={s._id} className="col-xxl-4 col-lg-4 col-md-4 col-12">
                    <div className="listing-item" style={{ border: "1px solid #febf6c" }}>
                      <div className="listing-img">
                        <div className="img-slider listing-page-slider">
                          {/* <Slider {...settings1}></Slider> */}
                            <div className="slide-images">
                              <Link to={`${routes.listingDetails}${s.slug}`}>
                                <img
                                  src={`${S3CDNURL}${s.image}`}
                                  style={{
                                      height: advanceFilter ? '180px' : '220px',
                                      objectFit: 'cover'
                                    }}
                                  className="img-fluid"
                                  alt={s.name}
                                />
                              </Link>
                            </div>
                        </div>
                        <span className="featured-text">
                          {showTitleMaster(s.brand, carBrand)}
                        </span>
                      </div>
                      <div className="listing-content">
                        <div className="listing-features d-flex align-items-end justify-content-between">
                          <div className="list-rating">
                            <h3 className="listing-title">
                              <Link to={`${routes.listingDetails}${s.slug}`}>
                                {s.name}
                              </Link>
                            </h3>
                            <div className="list-rating">
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star filled" />
                              <i className="fas fa-star-half filled" />
                              <span>
                                  (4.7)
                                {/* 138 Reviews */}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="listing-details-group">
                          <ul>
                            <li>
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-parts-01.svg"
                                  alt="Auto"
                                />
                              </span>
                              <p>{showTitleMaster(s.transmission, carTransmission)}</p>
                            </li>
                            <li>
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-parts-07.svg"
                                  alt="10 KM"
                                />
                              </span>
                               <p>{showTitleMaster(s.category, carCategory)}</p>
                            </li>
                            <li>
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-parts-03.svg"
                                  alt="Petrol"
                                />
                              </span>
                              <p>{showTitleMaster(s.fuel, carFuel)}</p>
                            </li>
                          </ul>
                          <ul>
                            <li>
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-parts-04.svg"
                                  alt="Power"
                                />
                              </span>
                              <p>{showTitleMaster(s.steering, carSteering)}</p>
                            </li>
                            <li>
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-parts-05.svg"
                                  alt='2018'
                                />
                              </span>
                              <p>{s.year ? s.year : 'NA'}</p>
                            </li>
                            <li>
                              <span>
                                <ImageWithBasePath
                                  src="assets/img/icons/car-parts-06.svg"
                                  alt="Persons"
                                />
                              </span>
                              <p>{showTitleMaster(s.seat, carSeat)}</p>
                            </li>
                          </ul>
                        </div>
                    {s &&
                      s?.pricing &&
                      pickUpDate && 
                      dropOffDate && 
                      pickUpTime && 
                      dropOffTime && 
                        <CarPackagesSelect
                          carID={s?._id}
                          carPackages={carsPackages}
                          carPackagPricing={s?.pricing}
                          selectedPackage={selectedPackage}
                          setSelectedPackage={setSelectedPackage}
                          pickUpDate={pickUpDate}
                          dropOffDate={dropOffDate}
                          pickUpTime={pickUpTime}
                          dropOffTime={dropOffTime}
                        />}
                        
                        <div className="listing-button">
                          <Link
                            to={`${routes.listingDetails}${s.slug}`}
                            className="btn btn-order"
                          >
                            <span>
                              <i className="feather icon-calendar me-2" />
                            </span>
                            Rent Now
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/* /col */} 
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Car Grid View */}
    </div>
  );
};

export default ListingGrid;
